import {
  parseSearchArrayValue,
  parseSearchNumberValue,
  parseSearchStringValue,
  parseSearchBooleanValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type { IRpmOnboardingStatusReportFilters } from 'infrastructure/interfaces';

const defaultFilter: IRpmOnboardingStatusReportFilters = {
  clinicGuid: [],
  doctorGuid: [],
  referralDateSort: 'asc',
  childClinic: true,
  page: 1,
};

const parseFunctions: TParseFunctions<IRpmOnboardingStatusReportFilters> = {
  page: parseSearchNumberValue,
  doctorGuid: parseSearchArrayValue,
  patientGuid: parseSearchStringValue,
  clinicGuid: parseSearchArrayValue,
  status: parseSearchStringValue,
  childClinic: parseSearchBooleanValue,
  referralDateSort: parseSearchStringValue,
};

export const useOnboardingStatusQueryFilter = () => {
  return useQueryFilterNew<IRpmOnboardingStatusReportFilters>(
    defaultFilter,
    parseFunctions,
    ['page'],
  );
};
